import { jsx as _jsx } from "react/jsx-runtime";
import { Toaster as Sonner } from 'sonner';
import { useTheme } from '../../theme';
import { HugeiconsIcon } from '@hugeicons/react';
/*
 * ИКОНКИ - ПОШТУЧНЫМ ПУТЁМ, А НЕ ИЗ ОБЩЕГО ФАЙЛА ПАКЕТА.
 *
 * `@hugeicons/core-free-icons@4.3.4` в своём общем файле импортирует шесть
 * иконок сетки с неверным регистром в имени (`Grid2x2CheckIcon.js` вместо
 * `Grid2X2CheckIcon.js`). На macOS файловая система регистр не различает и
 * сборка проходит; на Linux - CI и Cloudflare Pages - падает шестью
 * «Module not found». Поимённый путь общего файла не касается, и ошибка
 * пакета до нас не доходит; заодно в сборку не тянется перечисление
 * двенадцати тысяч иконок.
 */
import CheckmarkCircle02Icon from '@hugeicons/core-free-icons/CheckmarkCircle02Icon';
import InformationCircleIcon from '@hugeicons/core-free-icons/InformationCircleIcon';
import Alert02Icon from '@hugeicons/core-free-icons/Alert02Icon';
import MultiplicationSignCircleIcon from '@hugeicons/core-free-icons/MultiplicationSignCircleIcon';
import Loading03Icon from '@hugeicons/core-free-icons/Loading03Icon';
/*
 * Тема берётся из НАШЕГО источника, а не из `next-themes`.
 *
 * Поставка компонента ждёт провайдера `next-themes`; у продукта тема своя
 * (`packages/ui/src/theme.ts`, признаки `data-theme` и класс `dark`), и
 * второй источник правды о теме означал бы светлый тост на тёмном экране.
 */
const Toaster = ({ ...props }) => {
    const { theme } = useTheme();
    return (_jsx(Sonner, { theme: theme, className: "toaster group", icons: {
            success: _jsx(HugeiconsIcon, { icon: CheckmarkCircle02Icon, strokeWidth: 2, className: "size-4" }),
            info: _jsx(HugeiconsIcon, { icon: InformationCircleIcon, strokeWidth: 2, className: "size-4" }),
            warning: _jsx(HugeiconsIcon, { icon: Alert02Icon, strokeWidth: 2, className: "size-4" }),
            error: (_jsx(HugeiconsIcon, { icon: MultiplicationSignCircleIcon, strokeWidth: 2, className: "size-4" })),
            loading: (_jsx(HugeiconsIcon, { icon: Loading03Icon, strokeWidth: 2, className: "size-4 animate-spin" })),
        }, style: {
            '--normal-bg': 'var(--popover)',
            '--normal-text': 'var(--popover-foreground)',
            '--normal-border': 'var(--border)',
            '--border-radius': 'var(--radius)',
        }, toastOptions: {
            classNames: {
                toast: 'cn-toast',
            },
        }, ...props }));
};
export { Toaster };
//# sourceMappingURL=sonner.js.map